export default __webpack_public_path__ + "static/law-enforcement-87544213135641253d2fc1e5964d7b39.svg";